import inputErrorTemplate from '../templates/inputError.hbs';
import $ from 'jquery';

$.fn.sdaError = function(msg) {
    const that = this;
    const width = that.outerWidth();
    const offset = that.offset();
    const $el = $(inputErrorTemplate(msg));

    if (that.hasClass('sda-error')) {
        that.sdaRemoveError();
    }

    that.addClass('sda-error').after($el);
    $el.css({width});
    $el.offset(offset);
    if (that.is('input') || that.is('textarea')) {
        that.on('focus.fieldChanged', function() {
            that.sdaRemoveError();
            that.off('focus.fieldChanged');
        });
    }

    $el.addClass('flag-visible');

    return that;
};

$.fn.sdaRemoveError = function() {
    const that = this;

    if (that.hasClass('sda-error')) {
        that.removeClass('sda-error')
            .next()
            .remove();
        that.off('keyup.fieldChanged');
    }

    return that;
};

$.fn.sdaToggleError = function(message, shouldShowError) {
    return shouldShowError ? this.sdaError(message) : this.sdaRemoveError();
};
